import type IntentSignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/intent/IntentSignalFilters";
import type SignalCreateDTO from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalCreateDTO";
import type SignalUpdateDTO from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalUpdateDTO";
import type UISignal from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignal";

import type Signal from "../core/Signal";
import type SignalFilters from "../core/SignalFilters";
import type SignalSource from "../core/SignalSource";
import SignalType from "../core/SignalType";
import type { SignalTemplateDeps } from "../templates/SignalTemplate";
import SignalTemplate from "../templates/SignalTemplate";

type IntentSignalTemplateDeps = Omit<SignalTemplateDeps<IntentSignalFilters>, "signalType">;

export default class IntentSignalTemplate extends SignalTemplate<IntentSignalFilters> {
    constructor(deps: IntentSignalTemplateDeps) {
        super({ ...deps, signalType: SignalType.Intent });
    }

    isValid(): boolean {
        return true;
    }

    matchesSignal(signal: Readonly<Signal<IntentSignalFilters>>): boolean {
        return signal.signalType === this.signalType;
    }

    getSignalCreateDTO<F extends SignalFilters>(
        filters: Readonly<F>,
        signalSource: SignalSource,
    ): Readonly<SignalCreateDTO<F>> {
        return {
            isDefault: false,
            signalType: this.signalType,
            signalSource: signalSource,
            signalSubType: this.signalSubType,
            lifecycleStatus: this.lifecycleStatus,
            filters,
        };
    }

    getSignalUpdateDTO<F extends SignalFilters>(
        uiSignal: Readonly<UISignal<F>>,
        filters: Readonly<F>,
    ): Readonly<SignalUpdateDTO<F>> {
        const { id, isDefault } = uiSignal;
        return {
            id,
            isDefault,
            signalType: this.signalType,
            signalSubType: this.signalSubType,
            filters,
        };
    }
}
